import { render, staticRenderFns } from "./InvalidLicense.vue?vue&type=template&id=645673ed"
import script from "./InvalidLicense.vue?vue&type=script&lang=js"
export * from "./InvalidLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports